<div class="header">
  <div class="image">
    <img [src]="image" [src-fallback]="imagePlaceholder">
  </div>
  <div class="name">{{ name }}</div>
</div>
<div class="body">
  <p [innerHTML]="description"></p>
</div>
